/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { onboardinErrorObject } from '@constants/errorObjects';

import { useTranslation, Trans } from 'react-i18next';
import { showError } from '@store/common/actions';
import useBreakpoint from '@hooks/breakpoint';
import * as ROUTES from '@constants/routes';
import useQuery from '@hooks/useQuery';
import { LoginHeader, Header, Spinner, RePasswordForm } from '@components';
import { resetPassword, validateTokenResetPassword } from '@services/users-service';

const Container = styled.div`
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

const ResetPasswordInvitation = () => {
  const [errorEndpoint, setErrorEndpoint] = useState(false);

  const [ready, setReady] = useState(true);
  const { mobile } = useBreakpoint();
  const token = useQuery().get('t');
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (!token) {
    history.push(ROUTES.LOGIN);
  }

  useEffect(() => {
    validateTokenResetPassword(token)
      .then(() => {
        setReady(true);
      })
      .catch((error) => {
        dispatch(showError(onboardinErrorObject(error)));
        history.push(ROUTES.LOGIN);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (password) => {
    try {
      await resetPassword({
        password,
      });
      setReady(true);
      history.push(ROUTES.SUCCESS_RESET_PASSWORD);
    } catch (error) {
      const customMessage =
        error.message === 'Password invalid'
          ? t('passwordForms.errorForPassword')
          : t('passwordForms.errorForService');
      setReady(true);
      dispatch(showError(onboardinErrorObject({ message: customMessage })));
      if (error.message === 'Password invalid') {
        setErrorEndpoint(true);
      } else {
        setErrorEndpoint(false);
      }
    }
  };

  const initialState = {
    clickedSecondInput: false,
  };

  const [state, setState] = useState(initialState);

  const handleSecondInputClick = () => {
    setState({ ...state, clickedSecondInput: true });
  };

  const handleFirstInputClick = () => {
    setErrorEndpoint(false);
    setState({ ...state, clickedSecondInput: false });
  };

  return (
    <>
      {ready ? (
        <Container>
          {mobile ? <Header withoutTextMobile isResetPass /> : <LoginHeader isResetPass />}
          <>
            <RePasswordForm
              title={t('passwordForms.titleCreatePassword')}
              subtitle={<Trans i18nKey="passwordForms.subtitleTitleChangePassword" />}
              handleSubmit={handleSubmit}
              errorEndpoint={errorEndpoint}
              handleFirstInputClick={handleFirstInputClick}
              handleSecondInputClick={handleSecondInputClick}
              state={state}
              showCheckPrivacyPolicy={false}
              viewTyc={false}
              showPolicies={false}
              isCreate
            />
          </>
        </Container>
      ) : (
        <Spinner aligned />
      )}
    </>
  );
};

export default ResetPasswordInvitation;
